<template>
  <v-app>

     <v-app-bar app clipped-left clipped-right color="brown lighten-5" v-if="isScreenSmall"> <!-- #1C4E80 green darken-4 7b0a6b 083759 -->
     <img src="@/assets/idr_peq.png" align="left"/>
      <v-spacer />
      <v-toolbar-title >{{ tituloMobile }}</v-toolbar-title><!-- style="width: 300px" 212px -->
    <v-spacer />
      <img src="@/assets/logo-celepar-p.png" align="right"/>
    </v-app-bar>
    <v-app-bar app clipped-left clipped-right color="brown lighten-5" v-else> <!-- #1C4E80 green darken-4 7b0a6b 083759 -->
      <img src="@/assets/idr_med.png"/>
      <v-spacer />
      <v-toolbar-title style="width: 600px">{{ tituloGrande }}</v-toolbar-title><!-- style="width: 300px" 212px -->
      <v-spacer />
      <img src="@/assets/logo-celepar-m.png"/>
  </v-app-bar>

    <v-content>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </v-content>

  </v-app>
</template>

<script>
//import Navegacao from './components/Navegacao'

export default {
  name: 'App',
  data: () => ({
    tituloGrande: 'Instituto de Desenvolvimento Rural do Paraná (IDR-Paraná)',
    tituloMobile: 'IDR-PR'
  }),
  components: {
    //Navegacao
  },
      mounted () {
      //console.log(this.$vuetify.breakpoint.width)
      //console.log(this.$vuetify.breakpoint.height)
  },
  computed: {
    isScreenSmall() {
        return (this.$vuetify.breakpoint.width < 640 && this.$vuetify.breakpoint.height < 960)
    }
//    loading () {
//      return this.$store.getters.loading
//    }
  },
  methods: {
    atualizarTitulo(novoTitulo){
      this.tituloGrande = novoTitulo;
    },
    atualizarTituloMobile(novoTitulo){
      this.tituloMobile = novoTitulo;
    }
  }
}
</script>

<style>

.leaflet-container {
  z-index: 0;
}

/* Custom Info Control */
@media only screen and (min-width: 601px){
  .leaflet-info {
    padding: 6px 8px;
    font: 14px/16px Arial, Helvetica, sans-serif;
    background: rgba(255,255,255,0.8);
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
    border-radius: 10px;
  /*
    box-shadow: 0 0 15px rgba(0,0,0,0.2);
    border-radius: 5px;
  */
  }
}

@media only screen and (max-width: 600px){
  .leaflet-info {
  padding: 4px 6px;
  font: 12px/14px Arial, Helvetica, sans-serif;
  background: rgba(255,255,255,0.8);
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
  border-radius: 10px;
/*
  box-shadow: 0 0 15px rgba(0,0,0,0.2);
  border-radius: 5px;
*/
  }
}

.leaflet-info:hover {  
  background: gainsboro ;
}

.leaflet-info h4 {
  margin: 0 0 5px;
  color: #777;
}
/* Custom Legend Control */
.leaflet-legend {
  line-height: 18px;
  color: #555;
}
.leaflet-legend i {
  width: 18px;
  height: 18px;
  float: left;
  margin-right: 8px;
  opacity: 0.7;
}
/* Custom Changes */

.leaflet-bar {
/*  box-shadow: 0 1px 3px rgba(0,0,0,0.65); */
  box-shadow: 0 1px 5px rgba(0,0,0,.4);
}
.leaflet-popup-content {
  font-family: Roboto;
  font-size: .8125rem;
}
.leaflet-popup-content p {
  margin-top: 8px;
  margin-bottom: 8px !important;
}
/*
.leaflet-popup-content-wrapper {
  border-radius: 4px;
}
.leaflet-popup-content-wrapper, .leaflet-popup-tip {
//  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}
*/
.leaflet-bar a, .leaflet-bar a:hover {
  width: 30px;
  height: 30px;
  line-height: 30px;
  color: black !important;
/*
  color: white !important;
  background-color: black !important;
*/
}
.leaflet-touch .leaflet-bar a{
  width: 30px;
  height: 30px;
  line-height: 30px;
}

/* Custom Controls */
.leaflet-control-homeextent-toggle {
  background-image: url('assets/homeextent.svg');
}
/* Custom Controls */
.leaflet-control-coordextent-toggle {
  background-image: url('assets/coordextent.svg');
  background-size: 26px 26px;
}
.leaflet-control-getfeatureinfo-toggle {
  background-image: url('assets/information-variant.svg');
}
a.leaflet-control-active, a.leaflet-control-active:hover {
  background-color: #4CAF50;
}

/* Geocodificação - Tamanho do Botão */
.leaflet-control-geocoder-icon {
  width: 30px !important;
  height: 30px !important;
}
/* Geoman */
.leaflet-pm-toolbar .leaflet-buttons-control-button {
  padding: 6px;
}

/* Browser Print */
ul.browser-print-holder {
  padding-left: 0px !important;
}

</style>
